export default (value: string): null | number => {
  if (value === undefined || value === null) {
    return null;
  }
  const value2 = parseFloat(value);
  return isNaN(value2) ? null : Math.round(value2);
};
